import { Outlet } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { useTheme, useMediaQuery } from '@mui/material';
import { motion, useReducedMotion } from 'framer-motion';

type MainLayoutProps = {
  children?: React.ReactNode;
};

const MainLayout = ({ children }: MainLayoutProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const shouldReduceMotion = useReducedMotion();

  // Configuration des animations pour une expérience mobile fluide

  return (
    <Box sx={{ 
      minHeight: '100vh', 
      display: 'flex', 
      flexDirection: 'column', 
      bgcolor: 'background.default', 
      color: 'text.primary',
      pt: isMobile ? '64px' : '20px', // Réduit l'espace pour la navbar fixée
      '@media print': { pt: 0 }
    }}>
      <Navbar />
      <Container 
        maxWidth={false}
        disableGutters
        sx={{ 
          flex: 1, 
          py: 0, 
          px: 0,
          display: 'flex', 
          flexDirection: 'column', 
          width: '100%',
          maxWidth: '100%',
          margin: 0
        }}
      >
        <motion.div
          initial={shouldReduceMotion ? false : { opacity: 0 }}
          animate={shouldReduceMotion ? { opacity: 1 } : { opacity: 1 }}
          transition={shouldReduceMotion ? { duration: 0 } : { duration: 0.2 }}
          style={{ display: 'flex', flexDirection: 'column', flex: 1 }}
        >
          {children || <Outlet />}
        </motion.div>
      </Container>
      <Footer />
      <Toaster 
        position="top-center" 
        toastOptions={{
          style: {
            borderRadius: '8px',
            padding: '12px 16px',
            fontSize: isMobile ? '0.9rem' : '1rem',
            maxWidth: isMobile ? '90%' : '400px',
          },
          duration: 3000,
        }}
      />
    </Box>
  );
};

export default MainLayout;
